module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"label":"Login","pending":"Waiting for a reply","available":"Login is available","not-available":"Login is not available"},"fr_FR":{"label":"Identifiant","pending":"En attente d\u0027une réponse","available":"Identifiant disponible","not-available":"Identifiant non disponible"}}')
  delete Component.options._Ctor
}
